import React, { useEffect } from 'react';
import { X } from 'lucide-react';

interface ToastProps {
  message: string;
  type: 'success' | 'error' | 'info';
  onClose: () => void;
  duration?: number;
  icon?: React.ReactNode;
  config?: any;
}

export const Toast: React.FC<ToastProps> = ({
  message,
  type,
  onClose,
  duration = 2000,
  icon,
  config
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className="fixed bottom-20 inset-x-4 z-[400]">
      <div 
        className="max-w-sm mx-auto rounded-lg shadow-lg"
        style={{ 
          backgroundColor: config?.['major-color'] || '#6B7280',
          borderRadius: config?.border_radius || '0.5rem'
        }}
      >
        <div className="flex items-start justify-between p-4">
          <div className="flex items-start gap-3">
            {icon && <div className="shrink-0 text-white">{icon}</div>}
            <p className="text-white whitespace-pre-line">{message}</p>
          </div>
          <button
            onClick={onClose}
            className="ml-4 text-white hover:opacity-75 transition-opacity shrink-0"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};